import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import moment from "moment";
import * as XLSX from "xlsx";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import { checkUserPermission } from "../../../common/UserPermission";

const VendorContactList = (props) => {
  let PERMISSION_EDIT = "/manage-suppliers/:id";
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate, ReportViewPermission } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [classicView, setClassicView] = useState(true);
  const apicall = () => {
    axios
      .get(
        `${config.reportsBaseUrl}/reports/vendorcontactlist?filtercolumnsearchtext=&currentorder=0&ordercolumn=0&pagesize=&pagenumber=&filtertext=&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    apicall();
  }, []);

  // const columns = useMemo(() => [
  //   {
  //     header: "ID",
  //     accessorKey: "ID",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Vendor Name",
  //     accessorKey: "Vendor",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Phone",
  //     accessorKey: "PhoneNumber",
  //     filterFn: "contains",
  //     size: "110",
  //     Cell: ({ row }) =>
  //       row.original.PhoneNumber !== 0 ? row.original.PhoneNumber : "",
  //   },
  //   {
  //     header: "Fax",
  //     accessorKey: "Fax",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "Email",
  //     accessorKey: "Email",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "City",
  //     accessorKey: "City",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "State",
  //     accessorKey: "State",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "Zip",
  //     accessorKey: "Zip",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "Country",
  //     accessorKey: "Country",
  //     filterFn: "contains",
  //     size: "100",
  //   },
  //   {
  //     header: "Account Number",
  //     accessorKey: "AccountNumber",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Terms",
  //     accessorKey: "Terms",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Company Name",
  //     accessorKey: "Companyname",
  //     filterFn: "contains",
  //     size: "140",
  //   },
  //   {
  //     header: "Created Date",
  //     accessorKey: "CreatedDate",
  //     filterFn: "contains",
  //     size: "140",
  //     CreatedBy
  //   },
  //   {
  //     header: "Created By",
  //     accessorKey: "CreatedBy",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Modified Date",
  //     accessorKey: "ModifiedDate",
  //     filterFn: "contains",
  //     size: "140",
  //     Cell: ({ row }) => {
  //       const ModifiedDate = row?.original?.ModifiedDate;
  //       if (
  //         ModifiedDate === "00-00-0000" ||
  //         ModifiedDate === "" ||
  //         ModifiedDate === null
  //       ) {
  //         return "";
  //       }
  //       return moment(ModifiedDate).format("MM/DD/YYYY  (HH:mm)");
  //     },
  //   },
  //   {
  //     header: "Modified By",
  //     accessorKey: "ModifiedBy",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Address",
  //     accessorKey: "ShippingAddress",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Website",
  //     accessorKey: "Website",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Note",
  //     accessorKey: "Note",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  //   {
  //     header: "Is Deleted",
  //     accessorKey: "Deleted",
  //     filterFn: "contains",
  //     size: "110",
  //   },
  // ]);

  const columns = useMemo(() => [
    {
      header: "Vendor",
      accessorKey: "Vendor",
    },
    {
      header: "Phone",
      accessorKey: "PhoneNumber",
      Cell: ({ cell }) => {
        const formatPhoneNumber = (PhoneNumber) => {
          const cleaned = ("" + PhoneNumber).replace(/\D/g, "");
          const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
          }
          return PhoneNumber;
        };

        return formatPhoneNumber(cell.getValue());
      },
    },
    {
      header: "Email",
      accessorKey: "Email",
    },
    {
      header: "Full name",
      accessorKey: "FullName",
    },
    {
      header: "Billing address",
      accessorKey: "ShippingAddress",
      Cell: ({ row }) => {
        return [
          row?.original?.Address1,
          row?.original?.Address2,
          row?.original?.City,
          row?.original?.State + " " + row?.original?.Zip,
          row?.original?.Country,
        ]
          .filter(Boolean)
          .join(", ");
      },
    },
    {
      header: "Account #",
      accessorKey: "AccountNumber",
    },
    {
      header: "Billing city",
      accessorKey: "City",
    },
    {
      header: "Billing country",
      accessorKey: "Country",
    },
    {
      header: "Billing state",
      accessorKey: "State",
    },
    {
      header: "Billing zip",
      accessorKey: "Zip",
    },
    {
      header: "Company name",
      accessorKey: "Companyname",
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
    },
    {
      header: "Created date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        ),
    },
    {
      header: "Deleted",
      accessorKey: "Deleted",
    },
    {
      header: "First name",
      accessorKey: "FirstName",
    },
    {
      header: "Last Modified By",
      accessorKey: "ModifiedBy",
    },
    {
      header: "Last modified date",
      accessorKey: "ModifiedDate",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.ModifiedDate;
        if (
          ModifiedDate === "00-00-0000" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last name",
      accessorKey: "LastName",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
    },
  ]);

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);

  const Classiccolumns = [
    // {
    //   title: "Vendor",
    //   field: "Vendor",
    //   headerFilter: "input",
    //   frozen: true,
    //   defaultVisible: true,
    // },
    {
          title: "Vendor",
          field: "Vendor",
          headerFilter: "input",
          frozen: true,
          defaultVisible: true,
          formatter: function (cell, formatterParams, onRendered) {
            const rowData = cell.getRow().getData();
            const VendorName = rowData.Vendor;
            const VendorId = rowData.ID;
            // Check permission before rendering link
            if (checkUserPermission(PERMISSION_EDIT)) {
                      return `<span style="color:#343f62;font-weight:700;text-decoration:underline;cursor:pointer;" onclick="window.open('/manage-suppliers/${VendorId}', '_blank')">${VendorName}</span>`;
                    } else {
                      return `<span style="color:#343f62;font-weight:700;">${VendorName}</span>`;
                    }
          },
        },
    {
      title: "Phone Number",
      field: "PhoneNumber",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Email",
      field: "Email",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Full Name",
      field: "FullName",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Address",
      field: "Address",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "City",
      field: "City",
      // headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "State",
      field: "State",
      // headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Zip",
      field: "Zip",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Country",
      field: "Country",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Billingaddress",
      field: "ShippingAddress",
      headerFilter: "input",
      // defaultVisible: true,
    },
    // {
    //   title: "Billing address",
    //   field: "ShippingAddress",
    //   headerMenu: headerMenu,
      // headerFilter: "input",
    //   defaultVisible: true,
    // },

    {
      title: "Account #",
      field: "AccountNumber",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Billing city",
      field: "City",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Billing country",
      field: "Country",
      headerFilter: "input",
    },
    {
      title: "Billing state",
      field: "State",
      headerFilter: "input",
    },
    {
      title: "Billing zip",
      field: "Zip",
      headerFilter: "input",
    },
    {
      title: "Company name",
      field: "Companyname",
      headerFilter: "input",
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
    },
    {
      title: "Created date",
      field: "CreatedDate",
      headerFilter: "input",
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()} h:mm A`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Deleted",
      field: "Deleted",
      headerFilter: "input",
    },
    {
      title: "First name",
      field: "FirstName",
      headerFilter: "input",
    },
    {
      title: "Last Modified By",
      field: "ModifiedBy",
      headerFilter: "input",
    },
    {
      title: "Last modified date",
      field: "ModifiedDate",
      headerFilter: "input",
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()} h:mm A`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Last name",
      field: "LastName",
      headerFilter: "input",
    },
    {
      title: "Note",
      field: "Note",
      headerFilter: "input",
    },
    {
      title: "Terms",
      field: "Terms",
      headerFilter: "input",
    },
  ];

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Vendor Contact List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Vendor Contact List</li>
              </ul>
            </div>
          </div>
          <div className="card mt-3" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h6 className="p">SonarPos</h6>
                  <p className="fw-bold p-regular">Vendor Contact List</p>
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                {ReportViewPermission == true ? (
                  <button
                    className="btn btn-secondary"
                    onClick={() => setClassicView(!classicView)}
                  >
                    {" "}
                    {classicView ? "ClassicView" : "Morden View"}
                  </button>
                ) : (
                  <></>
                )}

                {classicView ? (
                  <CommonTabular
                    Data={responseData}
                    columns={Classiccolumns}
                    Groupvalue={[]}
                    Reportname={"Vendor_Contact_List"}
                    frozenRowvalue={0}
                    // layout={"fitDataFill"}
                    Onrefresh={() => apicall()}
                  />
                ) : (
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Vendor Contact List"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[]}
                    columnsVisibility={{
                      City: false,
                      Country: false,
                      State: false,
                      Zip: false,
                      CreatedBy: false,
                      Companyname: false,
                      ModifiedBy: false,
                      ShippingAddress: false,
                      Website: false,
                      Note: false,
                      CreatedDate: false,
                      Deleted: false,
                      FirstName: false,
                      ModifiedDate: false,
                      LastName: false,
                      Terms: false,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorContactList;
